enum FileTypes {
  IMAGE_PNG = 'image/png',
  IMAGE_JPG = 'image/jpeg'
}

export default FileTypes;
